/** Recorrido del asistente. Cada paso abre una vista del demo (sin BD). */

export const FINAL_GUIDE = [
  {
    view: 'dashboard',
    title: 'Así amanece tu día',
    body: 'Aquí ves calorías, proteína, carbohidratos, grasas, el agua y los pasos. Es tu tablero: un vistazo y ya sabes cómo vas.',
  },
  {
    view: 'plan',
    title: 'Primero, tu plan',
    body: 'Tu entrenador ya fijó las metas. Revisa las tarjetas de macros, los vasos y los pasos antes de registrar lo que comes.',
  },
  {
    view: 'nutrition',
    focus: 'local',
    title: '¿Comiste fuera? Elige el plato',
    body: 'En Nutrición, las comidas habituales cargan un plato conocido: hamburguesa El Corral, ensalada César o crepes. Un toque y queda en el día.',
  },
  {
    view: 'nutrition',
    focus: 'scan',
    title: 'O escanea el código',
    body: 'Apunta al código de barras del empaque. En este demo prueba el código de ejemplo: encuentra la avena y la dejas lista para registrar.',
  },
  {
    view: 'nutrition',
    focus: 'photo',
    title: 'También puedes fotografiar el plato',
    body: 'Sacas la foto, ves lo que se reconoció y confirmas los gramos. Aquí usamos una foto de ejemplo, sin enviar nada a internet.',
  },
  {
    view: 'nutrition',
    focus: 'manual',
    title: 'Y si prefieres, anótalo a mano',
    body: 'Busca el alimento y súmalo. Huevos, ensalada, batido: lo que registres mueve las barras del dashboard.',
  },
  {
    view: 'recipes',
    title: '¿La preparaste?',
    body: 'En Recetas del Chef eliges una receta y la registras. Así el día suma lo que cocinaste, no solo lo que compraste.',
  },
  {
    view: 'chat',
    title: 'Pregúntale a Nico',
    body: 'Con lo que ya registraste, Nico te orienta: proteína, cena o fruta de noche. En el demo las respuestas están listas para que veas cómo conversa.',
  },
  {
    view: 'measures',
    title: 'Mira cómo va tu cuerpo',
    body: 'Mira el video de cómo tomar las medidas y las gráficas de ejemplo: peso y centímetros. Tu entrenador usa esto para ajustar el plan.',
  },
  {
    view: 'report',
    title: 'Cuéntale cómo te sentiste',
    body: 'El reporte diario es tu voz: energía, hambre, sueño, ánimo. Con eso tu entrenador te acompaña y adapta el plan para que consigas tus resultados.',
  },
  {
    view: 'mytrainer',
    title: 'Alguien te acompaña',
    body: 'En Mi Entrenador ves quién lleva tu plan. En Perfil están tus datos. Ya puedes recorrer Food Plan a tu ritmo.',
  },
];

export const TRAINER_GUIDE = [
  {
    view: 'panel',
    title: 'Tus asesorados',
    body: 'El semáforo es el índice de adherencia al plan: verde si el cumplimiento es alto, amarillo si hay una desviación leve y rojo si hace falta un ajuste. No clasifica la comida en buena o mala.',
  },
  {
    view: 'localmeals',
    title: 'Los platos que ellos eligen',
    body: 'Este catálogo es el que el usuario ve en Nutrición. Publicas el plato, el restaurante y la porción; ellos lo registran con un toque.',
  },
  {
    view: 'vigencias',
    title: 'Quién sigue vigente',
    body: 'Licencias de menos a más días, alertas con 0 o días negativos y por vencer. Confirmar aquí solo mueve el demo: no cobra ni guarda en la base.',
  },
  {
    view: 'notifications',
    title: 'Las notas',
    body: 'Cuando un asesorado te escribe, llega aquí. La lees y sigues el acompañamiento sin salir de Food.',
  },
  {
    view: 'reminder',
    title: 'Recuérdales las medidas',
    body: 'Defines cada cuántos días pides una medida nueva. Así el progreso no se queda en una sola foto.',
  },
];
